import { TAB_INDEX } from '@/project/checklist/enums'

export const state = {
  globalAttachedFilesDialogIsOpen: false,
  deleteTaskModal: null,
  checklistPending: false,
  checklistDetailsPending: false,
  checklistStructure: [],
  checklistDetails: {
    sections: {},
    tasks: {},
  },
  checklistLastUpdateDate: null,
  checklistItemsBeingEdited: [],
  checklistTitleInputInvalid: false,
  checklistTableHeader: ['comments', 'status', 'responsibles', 'validators', 'date'],
  checklistDragItem: null,
  checklistDragOverSection: null,
  createTaskPending: false,
  createTaskError: null,
  editSectionPending: false,
  deleteSectionPending: false,
  createSectionPending: false,
  taskFolderPendingIds: [],
  currentTaskFolder: null,
  taskFolderError: null,
  tableTaskPane: {
    isOpen: false,
    tab: '',
    documents: [],
    parent: null,
    onCloseCallback: null,
  },
  checklistPane: {
    isOpen: false,
    tab: null,
    tasks: [],
    parent: null,
  },
  checklistShareByEmailPane: {
    isOpen: false,
    tab: '',
  },
  checklistVersioningPane: {
    documentVersions: [],
    documents: [],
    isOpen: false,
    removeVersionPending: false,
    tab: '',
  },
  editTaskPending: false,
  shareAttachedFilesPending: false,
  shareAttachedFilesError: null,
  moveFildersPending: false,
  moveFildersError: null,
  deleteFildersPending: false,
  deleteFildersError: null,
  renameAttachedFilePending: false,
  renameAttachedFileError: null,
  renameAttachedFilesDialog: {
    isOpen: false,
    fileToRename: null,
  },
  attachedFileVersionsPending: false,
  attachedFileVersions: null,
  attachedFileVersionsError: null,
  postAttachedFileVersionsPending: false,
  postAttachedFileVersionsError: null,
  selectedAttachedFiles: [],
  shareTasksDialog: {
    isOpen: false,
    tasksToShare: [],
    parent: null,
  },
  shareTaskRolePickerSelectedResponsibles: {
    groups: [],
    members: [],
  },
  shareTaskRolePickerSelectedObservers: {
    groups: [],
    members: [],
  },
  shareTaskRolePickerSelectedValidators: {
    groups: [],
    members: [],
  },
  shareTasksPending: false,
  shareTasksError: null,
  saveChecklistDialogIsOpen: false,
  saveChecklistPending: false,
  updateChecklistPending: false,
  saveChecklistError: null,
  importChecklistDialogIsOpen: false,
  importChecklistFromTemplateDialogIsOpen: false,
  checklistTemplatesSelectedTab: TAB_INDEX.UNSET,
  savedChecklistsPending: false,
  savedChecklists: [],
  selfSavedChecklistsPending: false,
  selfSavedChecklists: [],
  selectedSelfSavedChecklist: null,
  savedChecklistsError: null,
  selectedSavedChecklist: null,
  savedChecklistPreviewPending: false,
  savedChecklistPreview: null,
  savedChecklistPreviewError: null,
  lexisNexisChecklistsPending: false,
  lexisNexisChecklists: [],
  lexisNexisChecklistsError: null,
  selectedLexisNexisChecklist: null,
  lexisNexisChecklistPreviewPending: false,
  lexisNexisChecklistPreview: null,
  lexisNexisChecklistPreviewError: null,
  importChecklistFromClosdPending: false,
  importChecklistFromExcelPending: false,
  importChecklistFromClosdError: null,
  deleteSavedChecklistPending: false,
  deleteSavedChecklistError: null,
  shareSavedChecklistPending: false,
  shareSavedChecklistError: null,
  renameSavedChecklistPending: false,
  renameSavedChecklistError: null,
  lastItemAdded: null,
  taskCommentsPendingIds: [],
  paneTaskDetailsPendingIds: [],
  taskRightsPendingIds: [],
  taskCommentsError: null,
  postTaskCommentPendingIds: [],
  postTaskCommentError: null,
  deleteTaskCommentPendingIds: [],
  deleteTaskCommentError: null,
  deleteTaskPending: false,
  deleteTaskError: null,
  deleteChecklistDoubleValidationPending: false,
  contactResponsiblePending: false,
  contactResponsibleError: null,
  taskStatusCategoriesPending: false,
  taskStatusCategoriesError: null,
  taskStatusCategories: {},
  moveItemsPending: false,
  taskDetailsPendingIds: [],
  deleteTableSelectionPending: false,
  deleteTableSelectionError: null,
  duplicateTaskPending: false,
  duplicateTaskError: null,
  sectionsExpandState: [],
  shareChecklistByEmailPending: false,
  postStatusPending: false,
  postStatusError: null,
  selectedChecklistItems: {
    sections: [],
    tasks: [],
  },
  // Filters
  filters: [],
  filtersPaneIsOpen: false,
  // Search
  searchQuery: [],
  globalTaskFolderPending: false,
  globalTaskFolder: [],
  downloadTodoFilesPending: false,
  checklistPristine: true,
  updateTaskStatusesPending: [],
}
